<template>
  <button
    class="c-button c-chat__button"
    :class="{ active: chatStore.chatOpened, '-iconOnly': iconOnly }"
    :aria-label="$t('chat.messages')"
    @click="toggleChatDialog">
    <SvgIcon
      :medium="!smallIcon"
      :small="smallIcon"
      type="chat_bubble" />
    <span v-if="!iconOnly">{{ $t('chat.messages') }}
      <template
        v-if="chatStore.unreadThreadCount > 0">
        ({{ chatStore.unreadThreadCount }})
      </template></span>
  </button>
</template>

<script setup>
import { useChatStore } from '@/modules/chat/chatStore'

defineProps({
  iconOnly: {
    type: Boolean,
    default: false,
  },
  smallIcon: {
    type: Boolean,
    default: false,
  },
})

const chatStore = useChatStore()

const toggleChatDialog = () => {
  chatStore.chatOpened = !chatStore.chatOpened
}

</script>
